<app-bots
        [hideList]="true"
        [determinantMapById]="determinantMapById"
>
    <div class="row my-4" *ngIf="!bot">
        <div class="col-12">
            <div class="row">
                <div class="col-12 d-flex align-items-center">
                    <h2 class="page-title line-height-1">{{'Add bot' | translate}}</h2>
                </div>
            </div>
        </div>
    </div>

    <div class="role-main-tabs d-flex">
        <div *ngIf="bot" class="role-tab disabled foreground"><span class="highlight">{{ bot.name }}</span></div>
        <div class="role-tab {{activeTab === 'general' || (bot && (bot.botType === 'document' || bot.botType === 'message')) ? 'active-tab': ''}}" (click)="notifyTabChange('general')">
            {{ 'roles.generalTab' | translate }}
        </div>
        <div *ngIf="bot"
            class="role-tab {{activeTab === 'bot-service' && bot && (bot.botType === 'data' || bot.botType === 'internal') ? 'active-tab': ''}} {{ bot && (bot.botType === 'document' || bot.botType === 'message') ? 'hidden' : '' }}"
            (click)="notifyTabChange('bot-service')"
            [ngClass]="{'disabled': !mappingReady}">
            <i *ngIf="!mappingReady" class="far fa-sync-alt fa-spin"></i> {{ 'roles.botservice' | translate }}
        </div>
        <div *ngIf="bot" class="ml-auto disabled foreground align-items-center d-flex">
            <span (click)="openHistory()" class="btn btn-light btn-rounded btn-md text-uppercase align-self-center form-fields-btn role-history-button m-0">
                {{'Bot history' | translate}}
            </span>
        </div>
        <div class="align-items-center d-flex">
            <business-key *ngIf="bot?.businessKey"
                [businessKey]="bot?.businessKey"
                [tooltipPosition]="'left'"
                [businessKeyTooltip]="'Bot business key' | translate"
                [extraClass]="'ml-2'"> </business-key>
            <tutorial-layer
                    *ngIf="bot && bot.tutorials && bot.tutorials.general"
                    class="inpage-tutorial inline-tutorial-button"
                    title="{{ bot.name }}"
                    [isClosed]="true"
                    [editorData]="bot.tutorials.general"
                    (saveTutorial)="saveTutorial($event)">
            </tutorial-layer>
        </div>
    </div>

    <div class="role-main-tabs-content">
        <div *ngIf="bot" class="role-tab-content tab-general {{activeTab === 'general' || (bot && (bot.botType === 'document' || bot.botType === 'message')) ? 'active-tab': ''}}">
            <div class="role-tab-inner p-0">
                <role-bot-manage [serviceId]="serviceId" (changedData)="updatedRole()" [bot]="bot" *ngIf="activeTab === 'general' || (bot && (bot.botType === 'document' || bot.botType === 'message'))"></role-bot-manage>
            </div>
        </div>
        <div
            *ngIf="bot"
            class="role-tab-content mb-3 tab-bot-service {{activeTab === 'bot-service' ? 'active-tab': ''}} {{ bot && (bot.botType === 'document' || bot.botType === 'message') ? 'hidden' : '' }} {{this.store.state.common.lockedPageByUser ? 'locked-page' : ''}}">
            <div class="page-locker" *ngIf="this.store.state.common.lockedPageByUser"> </div>
            <service-role
                [bot]="bot"
                [serviceId]="serviceId"
                (saveData)="updateRole()"
                (reloadData)="reloadRole()"
                (mappingReady)="onMappingReady($event)">
            </service-role>
        </div>
    </div>

    <app-history-form
        *ngIf="showHistory && bot"
        [serviceId]="serviceId"
        [determinantMapById]="determinantMapById"
        [roleId]="bot.id"
        [historyController]="botController"
        [hidePreview]="true"
        (changeForm)="changeForm($event)"
        (closeLayer)="closeHistory()">
    </app-history-form>
    <div class="shadow"></div>
    <div class="row">
        <div class="col-12"></div>
    </div>
</app-bots>
